import { RocheUIContactPerson, RocheUIContactPersonLayout } from '@repo/roche-ui';
import React, { FC } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { blokToComponent } from '../../helpers/blok-to-component';

type RocheContactPersonProps = BlokToComponentProps<{
  name: string;
  job_title: string;
  phone_number?: string;
  email_address?: string;
  slotted_avatar: any[];
  layout: string;
}>;

export const RocheContactPerson: FC<RocheContactPersonProps> = ({ blok, getComponent, slot }) => {
  const slottedAvatar = blok.slotted_avatar?.map((avatar) =>
    blokToComponent({ getComponent, blok: avatar }, 'contact-person-avatar'),
  );

  return (
    <RocheUIContactPerson
      layout={blok.layout as RocheUIContactPersonLayout}
      name={blok.name}
      jobTitle={blok.job_title}
      phoneNumber={blok.phone_number}
      emailAddress={blok.email_address}
      slot={slot}
    >
      {slottedAvatar}
    </RocheUIContactPerson>
  );
};
